import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";

import {
  Stack,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormLabel,
  Tooltip,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ToggleButton,
  Autocomplete,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PreLoader } from "../../subcomponents/Preloader";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import { phoneTypes } from "../../../constants/PhoneTypes";
import { Languages } from "../../../constants/languages";
import GooglePlacesAutocomplete, {
  Place,
} from "../../subcomponents/GoogleAutocomplete";
import {
  validateLessonLocationField,
  validationMessages,
  MIN_TEXT_FIELD_LENGTH,
} from "../../actions/validations";
import {
  converttoDayjsTime,
  converttoStandardTime,
  propertyTime,
} from "../../../constants/PropertyInformation";
import { TutorialComponent } from "../../Tour/DemoTour";
import { RoomPropertyEnum } from "../../../constants/NavbarList";
import { YesOrNo } from "../../../constants/YesOrNo";
import { GolfPropertyTime } from "../../../constants/PropertyInformation";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";
import InfoIcon from "@mui/icons-material/Info";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DAYS } from "../../../constants/Days";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import DraggableItemList from "../../subcomponents/DNDComponent";
import { buttonValues, DNDFieldsEnum } from "../../../constants/Types";
import {
  checkData,
  deleteItem,
  fillAutocompleteValues,
  updateData,
} from "../../actions/actionItems";
import { GolfPropertyEnum } from "../../../constants/NavbarList";
import AlertComponent from "../../subcomponents/AlertComponent";
import {
  golfTooltipHeaders,
  originsTooltip,
} from "../../../constants/TooltipInformation";
import { removeSampleTestArray } from "../../actions/cleanup";
import { ClearButton } from "../../subcomponents/ClearButton";
import { CopyButton } from "../../subcomponents/CopyButton";

const GolfLessonLocation = ({
  data,
  fieldValues,
}: {
  data: any;
  fieldValues: any;
}) => {
  const [lessonlocation, setLessonlocation] = useState<string | null>(null);
  const [defaultt, setDefault] = useState<boolean>(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [lastUpdatedRecord, setLastUpdatedRecord] = useState<any>(null);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [GolfLessonLocations, setGolfLessonLocations] = useState<any>([]);
  const [lessonlocationError, setLessonlocationError] =
    useState<boolean>(false);
  const [lessonlocationErrorMessage, setLessonlocationErrorMessage] =
    useState<string>("");

  const validateLessonLocationInput = (): boolean => {
    if (!lessonlocation || lessonlocation.trim().length === 0) {
      setAlertMessage("Lesson Location is mandatory");
      setAlertType("error");
      setOpenAlert(true);
      return false;
    }

    setLessonlocationError(false);
    setLessonlocationErrorMessage("");

    if (lessonlocation.trim().length < MIN_TEXT_FIELD_LENGTH) {
      setLessonlocationError(true);
      setLessonlocationErrorMessage(validationMessages.lessonLocationMinLength);
      return false;
    }

    if (!validateLessonLocationField(lessonlocation)) {
      setLessonlocationError(true);
      setLessonlocationErrorMessage(validationMessages.lessonLocation);
      return false;
    }

    return true;
  };

  const updateGolfLessonLocations = () => {
    if (!validateLessonLocationInput()) {
      return false;
    }
    setGolfLessonLocations((prev: any) => {
      return (prev ?? []).map((item: any) => {
        if (item.id === selectedId) {
          return {
            ...item,
            ...payload,
          };
        }
        return item;
      });
    });
    editGolfLessonLocations(null);
    setEditClicked(false);
    setSelectedId(null);
    setAlertMessage(
      `${GolfPropertyEnum.playerAllocationBlock} updated successfully`,
    );
    setAlertType("success");
    setOpenAlert(true);
  };

  const addGolfLessonLocations = () => {
    if (!validateLessonLocationInput()) {
      return false;
    }
    setGolfLessonLocations((prev: any) => {
      return updateData(
        prev != null
          ? [
              ...prev,
              {
                id: (GolfLessonLocations?.length ?? 0) + 1,
                ...payload,
              },
            ]
          : [
              {
                id: 1,
                ...payload,
              },
            ],
      );
    });
    setLastUpdatedRecord(payload);
    editGolfLessonLocations(null);
    setEditClicked(false);
  };

  const editGolfLessonLocations = (list: any) => {
    list?.id && setSelectedId(list.id);
    list !== null && setEditClicked(true);
    setLessonlocation(list?.["Lesson Locations"]);
    setLessonlocationError(false);
    setLessonlocationErrorMessage("");
  };

  const deleteGolfLessonLocations = (id: number) => {
    setGolfLessonLocations(deleteItem(GolfLessonLocations ?? [], id));
  };
  useEffect(() => {
    if (fieldValues) {
      setGolfLessonLocations(fieldValues[GolfPropertyEnum.lessonLocation]);
    }
  }, []);

  useEffect(() => {
    data(GolfLessonLocations);
    editClicked &&
      setSelectedId(
        checkData(GolfLessonLocations, selectedId) ? selectedId : null,
      );
  }, [GolfLessonLocations]);

  const payload = {
    "Lesson Locations": lessonlocation,
  };
  return (
    <Stack>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
        }}
      >
        <Stack direction="row" width="100%" justifyContent="space-between">
          <Typography variant="h6" component="div" sx={textStyle}>
            Lesson Location
            <Tooltip title={tooltipComponent("")}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </Typography>
          <Stack direction="row" gap="10px" justifyContent="space-between">
            {editClicked && (
              <ClearButton
                click={() => {
                  editGolfLessonLocations(null);
                  setSelectedId(null);
                }}
              />
            )}
            {lastUpdatedRecord && (
              <CopyButton
                click={() => {
                  editGolfLessonLocations(lastUpdatedRecord);
                }}
              />
            )}
          </Stack>
        </Stack>
        <FormLabel component="legend">
          Lesson Location
          <Tooltip title={tooltipComponent(golfTooltipHeaders.minMinutes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <TextField
          id="lessonlocation"
          variant="outlined"
          placeholder="Lesson Location"
          value={lessonlocation ?? ""}
          onChange={(e: any) => {
            setLessonlocation(e.target.value);
            setLessonlocationError(false);
            setLessonlocationErrorMessage("");
          }}
          error={lessonlocationError}
          helperText={lessonlocationError ? lessonlocationErrorMessage : ""}
        />
        <Stack direction="row" width="100%" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{
              cursor: "pointer",
              border: "1px solid gray",
              borderRadius: "10px",
              background: "darkgreen",
              color: "white",
            }}
            onClick={() =>
              selectedId
                ? updateGolfLessonLocations()
                : addGolfLessonLocations()
            }
          >
            {selectedId ? buttonValues.UPDATE : buttonValues.ADD}
            Lesson Location
          </Button>
        </Stack>
        <Stack direction="column" gap="10px" mt={4}>
          <Typography variant="body2" sx={{ color: "red", fontWeight: 800 }}>
            Do not use sample data. Those are for demo purposes only!
          </Typography>
          <Typography variant="h6">Lesson Locations Available</Typography>
          <Stack direction="column" gap="10px">
            {GolfLessonLocations ? (
              <DraggableItemList
                itemData={GolfLessonLocations}
                onOrderUpdate={(order) => setGolfLessonLocations(order)}
                onEdit={(info) => editGolfLessonLocations(info)}
                onDelete={(id) => deleteGolfLessonLocations(id)}
                code={DNDFieldsEnum.LESSONLOCATION}
                name={DNDFieldsEnum.LESSONLOCATION}
              />
            ) : (
              <Typography variant="body2">
                No Allocation Block Information Available
              </Typography>
            )}
          </Stack>
        </Stack>
      </Paper>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        alertOpen={openAlert}
        closeAlert={() => setOpenAlert(false)}
      />
    </Stack>
  );
};

export default GolfLessonLocation;
